// extracted by mini-css-extract-plugin
export var commonFeatures = "FeatureCard-module--commonFeatures--YzIo+";